import { render } from "./AppSelectInput.vue?vue&type=template&id=fad4f1b0"
import script from "./AppSelectInput.vue?vue&type=script&lang=js"
export * from "./AppSelectInput.vue?vue&type=script&lang=js"

import "./AppSelectInput.vue?vue&type=style&index=0&id=fad4f1b0&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__